import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'PMT/i18n/I18n';

import Listener from 'PMT/flux/Listener';

// -- entities
import MenuPartCategory from 'PMT/entities/menu/MenuPartCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';

// -- constants
import Events from 'constants/Events';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- views
import { Modal } from 'react-bootstrap';
import View from './View';

export default class ModifyCategoryModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,

    category: PropTypes.instanceOf(MenuPartCategory),
    parentCategory: PropTypes.instanceOf(MenuPartCategory),

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu)
  };

  componentDidMount() {
    RestaurantMenuStore.addListeners([
      new Listener(
        Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_ERROR,
        this.onError
      ),
      new Listener(
        Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_SUCCESS,
        this.onChange
      ),
      new Listener(
        Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS,
        this.onChange
      ),
    ])
  }

  shouldComponentUpdate(nextProps: Object) {
    return nextProps.show !== this.props.show
        // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu)
      || this.props.category.equals(nextProps.category);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
  }

  onError = () => {
    this.props.onHide();
  }

  onChange = () => {
    this.props.onHide();
  };

  onHide = () => {
    this.props.onHide();
  };

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onHide}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('menu.menu_part_category.edit.modal_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <View
            {...this.props}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
